import React, { useState } from 'react';
import { productAPI } from '../../api';

const AdminProductUpload = ({ onProductAdded }) => {
  const [form, setForm] = useState({
    name: '',
    description: '',
    price: '',
    category: 'personal_care',
    stock: '',
    image: '', // Will hold the Cloudinary URL
    benefits: '',
    ingredients: '',
  });
  const [imageFile, setImageFile] = useState(null);
  const [uploading, setUploading] = useState(false);
    const handleImageChange = (e) => {
      const file = e.target.files?.[0];
      if (!file) {
        setImageFile(null);
        return;
      }
      if (!file.type.startsWith('image/')) {
        setError('Please upload an image file only.');
        setImageFile(null);
        return;
      }
      setError('');
      setImageFile(file);
    };

    const uploadImageToCloudinary = async (file) => {
      const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || 'dkhwthjov';
      const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || 'shreebakers';
      if (!cloudName || !uploadPreset) {
        throw new Error('Cloudinary environment variables are missing');
      }
      const data = new FormData();
      data.append('file', file);
      data.append('upload_preset', uploadPreset);
      const response = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
        method: 'POST',
        body: data
      });
      const uploaded = await response.json();
      if (!response.ok || !uploaded?.secure_url) {
        throw new Error(uploaded?.error?.message || 'Cloudinary upload failed');
      }
      return uploaded.secure_url;
    };
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    let imageUrl = form.image;
    try {
      if (imageFile) {
        setUploading(true);
        imageUrl = await uploadImageToCloudinary(imageFile);
        setUploading(false);
      }
      const payload = {
        ...form,
        image: imageUrl,
        price: Number(form.price),
        stock: Number(form.stock),
        benefits: form.benefits ? form.benefits.split(',').map(b => b.trim()) : [],
        ingredients: form.ingredients ? form.ingredients.split(',').map(i => i.trim()) : [],
      };
      await productAPI.createProduct(payload);
      setSuccess('Product uploaded successfully!');
      setForm({
        name: '', description: '', price: '', category: 'personal_care', stock: '', image: '', benefits: '', ingredients: '',
      });
      setImageFile(null);
      if (onProductAdded) onProductAdded();
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to upload product');
    } finally {
      setLoading(false);
      setUploading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl shadow mb-8">
      <h3 className="text-xl font-bold mb-4">Upload New Product</h3>
      {error && <div className="text-red-600 mb-2">{error}</div>}
      {success && <div className="text-green-600 mb-2">{success}</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input name="name" value={form.name} onChange={handleChange} required placeholder="Product Name" className="border p-2 rounded" />
        <input name="price" value={form.price} onChange={handleChange} required type="number" min="0" placeholder="Price" className="border p-2 rounded" />
        <select name="category" value={form.category} onChange={handleChange} required className="border p-2 rounded">
          <option value="Health_Supplements">Health Supplements</option>
          <option value="personal_care">Personal Care</option>
          <option value="fmcg">FMCG</option>
        </select>
        <input name="stock" value={form.stock} onChange={handleChange} required type="number" min="0" placeholder="Stock" className="border p-2 rounded" />
        <input type="file" accept="image/*" onChange={handleImageChange} className="border p-2 rounded" />
        <input name="image" value={form.image} onChange={handleChange} placeholder="Image URL (optional)" className="border p-2 rounded" />
        <input name="benefits" value={form.benefits} onChange={handleChange} placeholder="Benefits (comma separated)" className="border p-2 rounded" />
        <input name="ingredients" value={form.ingredients} onChange={handleChange} placeholder="Ingredients (comma separated)" className="border p-2 rounded" />
      </div>
      {uploading && <div className="text-blue-600 mt-2">Uploading image...</div>}
      <textarea name="description" value={form.description} onChange={handleChange} placeholder="Description" className="border p-2 rounded mt-4 w-full" />
      <button type="submit" disabled={loading} className="mt-4 px-6 py-2 bg-[#E4572E] text-white rounded-lg font-semibold hover:bg-[#F47C4D] transition-all">
        {loading ? 'Uploading...' : 'Upload Product'}
      </button>
    </form>
  );
};

export default AdminProductUpload;
